export const SPOOF_REQUESTED = 'SPOOF_REQUESTED';
export const SPOOF_STARTED = 'SPOOF_STARTED';
export const SPOOF_CANCELLED = 'SPOOF_CANCELLED';
export const SPOOF_STOPPED = 'SPOOF_STOPPED';
export const SPOOF_ERRORED = 'SPOOF_ERRORED';
